/**
 * Sistema visual dual: función en escala vs dedaje.
 * Los colores de dedo NUNCA deben coincidir con PEDAGOGICAL_DEGREE_HEX.
 */

import { PEDAGOGICAL_DEGREE_HEX } from "./scaleModuleTheme";

/** Dedos 1–5 (pulgar = 1 en piano estándar pedagógico). */
export const FINGER_COLORS: Record<1 | 2 | 3 | 4 | 5, string> = {
  1: "#3B82F6", // pulgar — azul
  2: "#22C55E", // índice — verde
  3: "#EAB308", // medio — ámbar
  4: "#F97316", // anular — naranja
  5: "#EC4899", // meñique — rosa
};

export const FINGER_LABELS: Record<1 | 2 | 3 | 4 | 5, string> = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
};

export type PracticeNoteVisualState =
  | "idle"
  | "expected"
  | "hit"
  | "late"
  | "miss"
  | "partial";

export const PRACTICE_STATE_STYLES: Record<
  PracticeNoteVisualState,
  { ring: string; glow: string; opacity: number }
> = {
  idle: { ring: "transparent", glow: "transparent", opacity: 0.35 },
  expected: { ring: "#fbbf24", glow: "rgba(251,191,36,0.45)", opacity: 1 },
  hit: { ring: "#34d399", glow: "rgba(52,211,153,0.5)", opacity: 1 },
  late: { ring: "#fb923c", glow: "rgba(251,146,60,0.45)", opacity: 1 },
  miss: { ring: "#fb7185", glow: "rgba(251,113,133,0.35)", opacity: 0.7 },
  partial: { ring: "#a78bfa", glow: "rgba(167,139,250,0.4)", opacity: 0.9 },
};

/** Re-exportar grados pedagógicos para capa de función. */
export { PEDAGOGICAL_DEGREE_HEX };

const DEGREE_INDEX: Record<string, number> = {
  R: 0,
  "1": 0,
  "2": 1,
  b2: 1,
  "3": 2,
  b3: 2,
  "4": 3,
  "#4": 3,
  "5": 4,
  b5: 4,
  "6": 5,
  b6: 5,
  "7": 6,
  b7: 6,
};

export function degreeColor(degree: string): string {
  const idx = DEGREE_INDEX[degree] ?? DEGREE_INDEX[degree.replace("b", "")] ?? 0;
  return PEDAGOGICAL_DEGREE_HEX[idx % PEDAGOGICAL_DEGREE_HEX.length];
}

export function fingerColor(finger: 1 | 2 | 3 | 4 | 5): string {
  return FINGER_COLORS[finger];
}

/** Estética Clavinova / mueble. */
export const PIANO_SHELL_THEME = {
  cabinetBg: "linear-gradient(180deg, #1a1816 0%, #0d0c0b 100%)",
  cabinetBorder: "rgba(232, 224, 212, 0.12)",
  wood: "#2a2420",
  woodHighlight: "#3d3530",
  displayBg: "rgba(0,0,0,0.55)",
  displayText: "#e8e0d4",
  displayAccent: "#c9405a",
  led: "#14b8a6",
  keyWhite: "#f5f0eb",
  keyBlack: "#1a1816",
  keyWhitePressed: "#ddd6ce",
  keyBlackPressed: "#0a0908",
} as const;
